import script from "./cateringOrders.vue?vue&type=script&setup=true&lang=js"
export * from "./cateringOrders.vue?vue&type=script&setup=true&lang=js"

import "./cateringOrders.vue?vue&type=style&index=0&id=72117e5c&lang=scss"

const __exports__ = script;

export default __exports__